import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import Pl from '../pages/pl/index.vue'/* 评论 */
import PinglunDetail from '../pages/pl/PinglunDetail.vue'/* 评论 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Recharge  from '../pages/mine/Recharge'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import GameDetail  from '../pages/mine/GameDetail'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import MoneyLog  from '../pages/mine/MoneyLog'/* 提现记录 */
import Mymove  from '../pages/mine/Mymove'/* 提现记录 */
import CacheManagement from '../pages/mine/CacheManagement'/* 缓存管理 */






Vue.use(VueRouter)
const routes = [
{path:'/',redirect:'/Home',component:Home,meta:{title:'Aura House'}},
{path:'/Home',name:'home',component:Home,meta:{title:'Aura House'}},
{path:'/Choose',name:'choose',component:Choose,meta:{title:'Profil Aura House'}},
{path:'/Pl',name:'pl',component:Pl,meta:{title:'Komentar Admin'}},
{path:'/PinglunDetail',name:'PinglunDetail',component:PinglunDetail,meta:{title:'Komentar Admin'}},
{path:'/List',name:'list',component:List,meta:{title:'Profil'}},
{path:'/Profile',name:'profile',component:Profile,meta:{title:'Profil'}},
{path:'/Mine',name:'mine',component:Mine,meta:{title:'Aura House'}},
{path:'/Video',name:'video',component:Video,meta:{title:'Video'}},
{path:'/Game',name:'game',component:Game,meta:{title:'Permainan'}},
{path:'/Login',name:'login',component:Login,meta:{title:'Masuk'}},
{path:'/Register',name:'register',component:Register,meta:{title:'Daftar'}},
{path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'Dukungan Langsung'}},
{path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'Dukungan Langsung'}},
{path:'/Setting',name:'Setting',component:Setting,meta:{title:'Pengaturan'}},
{path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'Informasi Profil'}},
{path:'/Setname',name:'Setname',component:Setname,meta:{title:'Edit Nama'}},
{path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'Edit Jenis Kelamin'}},
{path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'Kelola Kata Sandi Pembayaran'}},
{path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'Kelola Kata Sandi Masuk'}},
{path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'Halaman Detail'}},
{path:'/Notice',name:'Notice',component:Notice,meta:{title:'Romantik - Pengumuman'}},
{path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'Putar Video'}},
{path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'Tambah Kartu Bank'}},
{path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'Tambah Kartu Bank'}},
{path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'Tarik Dana'}},
{path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'Isi Saldo'}},
{path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'Laporan Pribadi'}},
{path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'Riwayat Penarikan'}},
{path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'Riwayat Transaksi'}},
{path:'/GameDetail',name:'GameDetail',component:GameDetail,meta:{title:'Detail Transaksi'}},
{path:'/MoneyLog',name:'MoneyLog',component:MoneyLog,meta:{title:'Aktivitas Saldo'}},
{path:'/Mymove',name:'Mymove',component:Mymove,meta:{title:'Romantik - Film Saya'}},
{path:'/CacheManagement',name:'CacheManagement',component:CacheManagement,meta:{title:'Kelola Cache'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    document.title = to.matched[0].meta.title
    next()
})

// 在生成路由实例后直接添加这一行：
router.push = (location) => {
    return VueRouter.prototype.push.call(router, location).catch(() => {})
}

export default router